import React, { FC, useMemo } from 'react';

import { useAction } from 'Modules/core/redux';
import { ModalComponentProps, useModalContext } from 'Modules/core/messaging';
import { ConfimationMessage } from 'Modules/business/ui';
import { Typography } from 'Modules/ui3';

import modalStyles from '../ui/index.module.scss';
import { FeedbackModalComponentProps, FeedbackModalStage } from './types';
import { FeedbackForm } from '../FeedbackForm';
import { ConfimationCode } from '../ConfirmationCode';
import { initialFormValues } from './utils';
import { feedbackActions } from '../../state/feedback';


const FeedbackModalComponent: FC<FeedbackModalComponentProps> = ({
    stage = FeedbackModalStage.INIT, formValues = {}, errorMessage, isError,
}) => {
    const { modal: { id } } = useModalContext();
    const sendForm = useAction((code: string) => feedbackActions.sendForm({
        modalId: id,
        ConfirmationCode: code,
        formValues,
    }), [id, formValues]);

    const requestCode = useAction(() => feedbackActions.sendCode(
        { email: formValues.email },
    ),
    [formValues.email]);

    const initialValues = useMemo(() => ({
        ...initialFormValues,
        ...formValues,
    }), [formValues]);

    if (stage === FeedbackModalStage.INIT)
        return <FeedbackForm formValues={initialValues} />;
    if (stage === FeedbackModalStage.CONFIRMATION) {
        return (
            <ConfimationCode
                email={formValues.email}
                errorMessage={errorMessage}
                onRequestCode={requestCode}
                onCodeEnter={sendForm}
            />
        );
    }

    if (stage === FeedbackModalStage.FINAL) {
        return (
            <ConfimationMessage
                success={!isError}
                messageTranslation='confirmationMessage'
                customErrorHelper={(
                    <>
                        <Typography variant='regularCaption1' sx={{ display: 'block' }}>
                            Пожалуйста, попробуйте еще раз или напишите нам на
                        </Typography>
                        <a href='mailto:ask@cfahub.ru'>
                            ask@cfahub.ru
                        </a>
                    </>
                )}
            />
        );
    }

    return null;
};

export const FeedbackModal: ModalComponentProps = {
    component: FeedbackModalComponent,
    containerClass: modalStyles.container,
    modalClass: modalStyles.modal,
    closeButtonVariant: 'dfaSmall',
};
